import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { ICON_HEADER } from 'src/app/shared/data/data';

type NavItem = {
  icon: string;
  iconActive: string;
  title: string;
  route?: string;
  path?: string; // legacy
  svg: boolean;
  role: string[];
};

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  @Output() action = new EventEmitter<boolean>();

  linksNavs: NavItem[] = ICON_HEADER as unknown as NavItem[];
  showMenuDetails = true;
  activeIconMenu = 0;
  userRole = '';

  constructor(
    private router: Router,
    private readonly authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.userRole = this.authService.readTypeUser();
    this.linksNavs = this.linksNavs.filter((link) =>
      link.role.includes(this.userRole),
    );

    this.syncActiveWithUrl(this.router.url);
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: any) =>
        this.syncActiveWithUrl(e.urlAfterRedirects ?? e.url),
      );
  }

  toggleMenu(value: boolean) {
    this.showMenuDetails = !this.showMenuDetails;
    this.action.emit(value);
  }

  showMore(index: number) {
    const item = this.linksNavs[index];
    const fallback = '/home/dashboard';

    this.activeIconMenu = index;
    this.router.navigateByUrl(item?.route ?? fallback);
  }

  private syncActiveWithUrl(currentUrl: string) {
    let bestIndex = 0;
    let bestLen = -1;

    this.linksNavs.forEach((item, idx) => {
      const r = item.route ?? '';
      if (!r) return;

      if (currentUrl.startsWith(r) && r.length > bestLen) {
        bestLen = r.length;
        bestIndex = idx;
      }
    });

    this.activeIconMenu = bestIndex;
  }
}
